import { FULL_HD, HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { getElementSize } from '../utils/sizes';
import { ITEMS_BY_BREAKPOINTS } from './customer/default/horizontalCard.constants';

export * from './customer/default/horizontalCard.constants';

export const templates = {
  HorizontalCard: 'HorizontalCard',
};

export const heights = {
  [HD]: 158,
  [FULL_HD]: 198,
};

export const imageOptions = {
  [templates.HorizontalCard]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        PRIMARY: {
          width: 281,
          height: 158,
        },
      },
      [FULL_HD]: {
        PRIMARY: {
          width: 353,
          height: 198,
        },
      },
    },
  },
};

const { sizes: elementSizes } = getElementSize(ITEMS_BY_BREAKPOINTS, 1.0, templates.HorizontalCard);

const buildSizes = context =>
  [FULL_HD, HD].reduce(
    (acc, size) => ({
      ...acc,
      [size]: {
        w: elementSizes[templates.HorizontalCard][context][size].w,
        h: heights[size],
      },
    }),
    {},
  );

export const sizes = {
  [templates.HorizontalCard]: {
    [RENDERING_CONTEXT.GENERAL]: buildSizes(RENDERING_CONTEXT.GENERAL),
    [RENDERING_CONTEXT.SEARCH]: buildSizes(RENDERING_CONTEXT.SEARCH),
  },
};
